import environment from '@app/environments/environment';
import axios from 'axios';
import { Injectable } from 'injection-js';

const baseUrl = environment.apiGateway.apiUrl;
const apiPathName = 'ClientLog/';
const apiUrl = baseUrl + apiPathName;

@Injectable()
export class LogService {
	public static async LogError(logMsg: string): Promise<any> {
		const url = apiUrl + 'LogError/';
		await axios.post(url, { LogMsg: logMsg });
	}

	public static async LogCritical(logMsg: string): Promise<any> {
		const url = apiUrl + 'LogCritical/';
		await axios.post(url, { LogMsg: logMsg });
	}

	public static async LogDebug(logMsg: string): Promise<any> {
		const url = apiUrl + 'LogDebug/';
		await axios.post(url, { LogMsg: logMsg });
	}

	public static async LogInformation(logMsg: string): Promise<any> {
		const url = apiUrl + 'LogInformation/';
		await axios.post(url, { LogMsg: logMsg });
	}

	public static async IsRequestToLogServiceApi(url: string) {
		return url.endsWith('apiPathName');
	}
}



// WEBPACK FOOTER //
// ./src/services/log.service.ts